// extracted by mini-css-extract-plugin
module.exports = {"sizeButton":"SizeSelector_sizeButton__nML_6","sizeText":"SizeSelector_sizeText___ISs6","selected":"SizeSelector_selected___LN_y"};